import { Inject, Injectable } from '@angular/core';
import { Resolve } from '@angular/router';
import { firstValueFrom } from 'rxjs';
import { environment } from 'src/environments/environment';
import {
  TOKEN_STORAGE_REPOSITORY,
  ITokenStorageRepository,
  LoginUseCase,
} from '@modules/auth';

@Injectable({
  providedIn: 'root',
})
export class AuthSessionResolver implements Resolve<boolean> {
  constructor(
    private readonly verifySessionUseCase: LoginUseCase,
    @Inject(TOKEN_STORAGE_REPOSITORY)
    private readonly tokenStorage: ITokenStorageRepository,
  ) {}

  async resolve(): Promise<boolean> {
    const token = this.tokenStorage.getToken();

    if (token) return true;

    const payload = {
      userName: environment.verifyData.user,
      password: environment.verifyData.passoword,
    };

    try {
      await firstValueFrom(this.verifySessionUseCase.execute(payload));
    } catch (error) {
      console.error('Error verifying session in resolver:');
    } finally {
      return true;
    }
  }
}
